module.exports = __webpack_public_path__ + "media/images/help/flow/eyecatch-phone-3517139476c64cda4d838c96de424280.svg";